import React, { useEffect, useState } from "react";
import { getCapital, getEquitySummary } from "../services/api.js";
import { getConfig } from "../config.js";

export default function CapitalWidget({ setCritical }){
  const [capital, setCapital] = useState(0);
  const [daily, setDaily] = useState({ change_percent: 0, change: 0 });
  const cfg = getConfig();

  useEffect(()=>{
    (async()=>{
      const cap = await getCapital();
      setCapital(cap.capital||0);
      const sum = await getEquitySummary("day");
      setDaily(sum||{change_percent:0,change:0});
      if (sum && typeof setCritical === 'function' && (sum.change_percent||0) < (cfg.DAILY_DROP_THRESHOLD||-3)){
        setCritical({ visible: true, message: `Warnung: Tagesverlust ${(sum.change_percent||0).toFixed(2)}% überschreitet Schwelle (${cfg.DAILY_DROP_THRESHOLD}%)` });
      }
    })();
  },[]);

  const up = (daily.change_percent||0) >= 0;

  return (
    <div className="card">
      <div className="text-sm opacity-70">Kapital</div>
      <div className="text-3xl font-semibold">{capital.toFixed(2)} €</div>
      <div className={`text-sm ${up?'text-green-600':'text-red-600'}`}>
        {up?'▲':'▼'} {(Math.abs(daily.change_percent||0)).toFixed(2)}% ({(daily.change||0).toFixed(2)} €) seit gestern
      </div>
    </div>
  );
}